module.exports = __webpack_public_path__ + "static/media/microphone-stand.233fd532.svg";